import { useTranslation } from "react-i18next";
import { Redirect, useLocation } from "react-router-dom";
import Insurance from "../Insurnace";

/**
 * Insurance → the products you offer. Selling a standalone policy lives on its own page
 * (`/sell-insurance`, "Buy Insurance Directly"); old `?tab=sales` links and payment-provider
 * returns that still point here are forwarded there with their query intact.
 */
const InsuranceHub = () => {
    const { t } = useTranslation("insuranceHub");
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    if (params.get("tab") === "sales" || params.has("payment")) {
        params.delete("tab");
        const search = params.toString();
        return <Redirect to={{ pathname: "/sell-insurance", search: search ? `?${search}` : "" }} />;
    }

    return (
        <div className="min-w-0">
            <div className="my-4 text-lg font-bold text-gray-900 sm:my-5 sm:text-[1.2rem]" data-tour="insurance-hub">
                {t("title")}
            </div>
            <p className="mb-4 text-sm text-gray-500">{t("tabs.productsHint")}</p>
            <div className="min-w-0">
                <Insurance embedded />
            </div>
        </div>
    );
};

export default InsuranceHub;
